import { HttpService } from 'services/http';


export const getCurrenciesAPI = (queryParams) => HttpService.get('/v3/currencies', queryParams);


export default { getCurrenciesAPI };

